import { render, staticRenderFns } from "./ManifestUpload.vue?vue&type=template&id=1253baa8&"
import script from "./ManifestUpload.vue?vue&type=script&lang=js&"
export * from "./ManifestUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports